import { render } from "./upgrade.vue?vue&type=template&id=0c202026&lang=pug"
import script from "./upgrade.vue?vue&type=script&lang=js"
export * from "./upgrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__